import reduce from 'lodash/reduce'
import moment from 'moment'
import momentTz from 'moment-timezone'
import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useLocalization } from '../../../localization'
import { validateEmail } from '../../../utils/auth'
import {
  CBAlert, // Added
  CBButton,
  CBCheckItem, // From CBRadio.js via cbd.js
  CBCheckbox, // Added
  CBColorPicker,
  CBHeader,
  CBInput,
  CBListItem,
  CBModal,
  CBMultiSelect, // Added
  CBRadioGroup, // From CBRadio.js via cbd.js
  CBSelect, // Added
  CBStep,
  CBSteps,
  CBTextArea,
  CBCustomTimePicker, // Added
  CBUrlField,
  SubmitButton
} from '../../core/components/cbd' // Assuming CBAlert, CBCheckbox, CBMultiSelect, CBSelect, CBTimePicker are exported here or need separate imports
import ScheduleImageUpload from '../components/ScheduleImageUpload'
// Define basic functional components to replace Ant Design Layout structure
const Layout = ({ children, ...props }) => <div {...props}>{children}</div>;
const Content = ({ children, ...props }) => <div {...props}>{children}</div>;
const Sider = ({ children, ...props }) => <div {...props}>{children}</div>;
// Header and Footer were destructured but not used, so they are omitted here.

// Removed Ant Design Typography imports
import { API } from 'aws-amplify'
import MediaQuery from 'react-responsive'
import SEO from '../../../components/SEO'
import { ReactComponent as Up } from '../../../images/svg/arrow-up-chevron.svg'
import { ReactComponent as NewSchedule } from '../../../images/svg/new-scheduler.svg'
import { ReactComponent as Edit } from '../../../images/svg/pencil.svg'
import { ReactComponent as Trash } from '../../../images/svg/trash-delete.svg'
import { useGlobalState } from '../../../store'
import ScheduleItem from '../components/ScheduleItem'

// Removed unused Panel and Step imports from Ant Design
const daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
const defaultStartTime = moment('9:00:00', 'HH:mm:ss')
const defaultEndTime = moment('17:00:00', 'HH:mm:ss')

class ScheduleCreatePage extends React.Component {
  state = {
    page: 0,
    showModal: false,
    lastPage: 2,
    allCalendars: [],
    readTooCalendars: [],
    existingScheduleId: null,
    filteredDestinationCalendars: [],
    minArray: ['60', '30', '15'],
    schedule: {
      source: undefined,
      startTime: defaultStartTime,
      endTime: defaultEndTime,
      days: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'],
      meetingIncrement: ['60'],
      bodyTemplate: '',
      timezone: momentTz.tz.guess(),
      dayRange: '30',
      greeting: '',
      label: '',
      others: [],
      questions: [],
      iconImage: '',
      avatarImage: '',
      militaryTime: false,
      bufferBefore: 0,
      bufferAfter: 0,
      leadTime: 0,
      meeting: false,
      destinationColor: 'default',
      integrations: [],
      startTimeSun: defaultStartTime,
      endTimeSun: defaultEndTime,
      startTimeMon: defaultStartTime,
      endTimeMon: defaultEndTime,
      startTimeTue: defaultStartTime,
      endTimeTue: defaultEndTime,
      startTimeWed: defaultStartTime,
      endTimeWed: defaultEndTime,
      startTimeThu: defaultStartTime,
      endTimeThu: defaultEndTime,
      startTimeFri: defaultStartTime,
      endTimeFri: defaultEndTime,
      startTimeSat: defaultStartTime,
      endTimeSat: defaultEndTime,
      alias: '',
      customSubject: '{invitee_name} and {my_name} - {subject}',
      additionalAttendees: [],
      startCrement: 0,
      sundayStart:true,
      language: 'en'
    },
    isLoading: false,

    questionInputValue: '',
    attendeeInput: '', // Added state for attendee input field
    attendeeError: null, // Added state for attendee validation error
    meetingLengthError: null, // Added state for meeting length validation error
  }

  getButtonLabelByStep() {
    const { t } = this.props; // Destructure t from props
    var label = ''
    switch (this.state.page) {
      case 0:
        // code block
        label = this.props.t('scheduler.continue_to_availability')
        break
      case 1:
        // code block
        label = this.props.t('scheduler.continue_to_event_details')
        break
      case 2:
        label = this.props.t('scheduler.review_and_create')
        break
      default:

      // code block
    }
    return label
  }

  componentDidUpdate(prevProps, prevState) {
    // listen in on the source calendar changes
    if (prevState.schedule.source !== this.state.schedule.source) {
      const { allCalendars, readTooCalendars } = this.state

      // find the calendar via source index
      const foundCalendar = allCalendars[this.state.schedule.source] ?? false

      // filter out the source calendar
      const filteredDestinationCalendars =
        foundCalendar && readTooCalendars.length
          ? readTooCalendars.filter(
              (calendar) => calendar.id !== foundCalendar.id
            )
          : readTooCalendars

      // don't replace readTooCalendars to maintain source of truth
      this.setState({
        filteredDestinationCalendars,
      })
    }
  }

  componentDidMount() {
    var otherError = ''
    const readTooCalendars = this.props.accounts
      .reduce((all, a) => [...all, ...a.calendars], [])

      .filter((item, index, self) => {
        // Find the index of the current item in the array
        const currentIndex = self.findIndex(
          (innerItem) => innerItem.id === item.id
        )

        // If the current index is the same as the current loop index, it's a unique item
        return currentIndex === index
      })
      .filter((calendar) => {
        if (
          calendar.name == 'Birthdays' ||
          calendar.name == 'United States holidays' ||
          calendar.summary == 'Birthdays' ||
          calendar.summary == 'Holidays in United States'
        ) {
          return false
        } else {
          return true
        }
      })

    const allCalendars = this.props.accounts
      .reduce((all, a) => [...all, ...a.calendars], [])
      .filter((c, i) => c.canEdit)

    // this.setState({

    // })
    this.setState({
      allCalendars,
      readTooCalendars,
      filteredDestinationCalendars: readTooCalendars,
    })

    if (this.props.id) {
      const existingSchedule = this.props.schedules.find(
        (s) => s.id === this.props.id
      )
      const allCalendarIdx = allCalendars.findIndex(
        (c) => c.id === existingSchedule.calendarId
      )

      //figure out others (now using IDs)
      var moreCals = [] // Will store valid calendar IDs

      var filteredReadToo = readTooCalendars.filter(
        (cal) => cal.id != existingSchedule.calendarId
      )
      const validCalendarIds = new Set(filteredReadToo.map(cal => cal.id)); // Set of available IDs for quick lookup

      if (existingSchedule.others != null) {
        // Filter existingSchedule.others to only include IDs present in filteredReadToo
        moreCals = existingSchedule.others
          .map(e => e.calendarId) // Get the IDs
          .filter(id => validCalendarIds.has(id)); // Keep only IDs that are still available

        // Check if any selected calendars were removed
        if (moreCals.length !== existingSchedule.others.length) {
           otherError = this.props.t('scheduler.error_missing_calendar_edit'); // Or a more specific error
        }
      }

      if (allCalendarIdx == -1) { // Only check source calendar index here
        otherError = this.props.t('scheduler.error_missing_calendar_edit');
      }

      var timeMatrix = existingSchedule.timeMatrix
      const existingStartTime = moment({
        hour: existingSchedule.startHour,
        minute: existingSchedule.startMin,
      })
      const existingEndTime = moment({
        hour: existingSchedule.endHour,
        minute: existingSchedule.endMin,
      })
      var timeTable = {}
      if (timeMatrix) {
        daysOfWeek.forEach((day) => {
          const dayObj = timeMatrix[day]
          if (dayObj) {
            var start = moment({
              hour: dayObj.startHour,
              minute: dayObj.startMin,
            })
            var end = moment({ hour: dayObj.endHour, minute: dayObj.endMin })
            timeTable['startTime' + day] = start
            timeTable['endTime' + day] = end
          } else {
            timeTable['startTime' + day] = existingStartTime
            timeTable['endTime' + day] = existingEndTime
          }
        })
      }
      const schedule = {
        source: allCalendarIdx,
        startTime: existingStartTime,
        endTime: existingEndTime,
        language: existingSchedule.language,
        sundayStart: existingSchedule.sundayStart,
        days:
          existingSchedule.dayOptions == ''
            ? []
            : existingSchedule.dayOptions
                .split(',')
                .map((d) => d[0].toUpperCase() + d.slice(1)),
        meetingIncrement: existingSchedule.meetingIncrement,
        bodyTemplate: existingSchedule.bodyTemplate.replace(
          /\<br\/\>/g,
          '\r\n'
        ),
        timezone: existingSchedule.tz,
        dayRange: existingSchedule.dayRange,
        others: moreCals,
        greeting:
          existingSchedule.greeting != ''
            ? existingSchedule.greeting
            : ``,
        label:
          existingSchedule.label != ''
            ? existingSchedule.label
            : existingSchedule.displayName,
        questions:
          existingSchedule.questions != null ? existingSchedule.questions : [],
        bufferBefore: existingSchedule.bufferBefore,
        bufferAfter: existingSchedule.bufferAfter,
        leadTime: existingSchedule.leadTime,
        meeting: existingSchedule.meeting,
        destinationColor:
          existingSchedule.destinationColor != 'default'
            ? existingSchedule.destinationColor
            : 'default',
        integrations: existingSchedule.integrations,
        //convert day matrix o_O
        ...timeTable,
        alias: existingSchedule.alias || '',
        iconImage: existingSchedule.iconImage,
        avatarImage: existingSchedule.avatarImage,
        militaryTime: existingSchedule.militaryTime,
        customSubject: existingSchedule.customSubject,
        additionalAttendees:
          existingSchedule.additionalAttendees === ''
            ? []
            : existingSchedule.additionalAttendees.split(','),
        startCrement: existingSchedule.startCrement,
        defaultTime: existingSchedule.defaultTime,
      }

      var minArray = this.state.minArray
      console.log('MIN ARRAY:' + minArray)
      var additional = existingSchedule.meetingIncrement.filter(
        (e) => (e != '60') & (e != '30') && e != '15'
      )
      if(otherError != '') {
        this.setState({quickSave: true})
      }
      // minArray = minArray.push(additional)
      minArray.push.apply(minArray, additional)
      this.setState({
        minArray: minArray
          .map((e) => parseInt(e, 10))
          .sort(function (a, b) {
            return a - b
          })
          .map((e) => e.toString()),
        existingScheduleId: this.props.id,
        schedule,
        filteredDestinationCalendars: filteredReadToo, // Ensure options match selected indices
        otherError,
      })
    }
  }

  createFauxItem = () => {
    const {
      source,
      startTime,
      endTime,
      days,
      meetingIncrement,
      bodyTemplate,
      timezone,
      destinationColor,
      dayRange,
      others,
      greeting,
      label,
      questions,
      bufferBefore,
      bufferAfter,
      leadTime,
      meeting,
      integrations,
      startTimeSun,
      endTimeSun,
      startTimeMon,
      endTimeMon,
      startTimeTue,
      endTimeTue,
      startTimeWed,
      endTimeWed,
      startTimeThu,
      endTimeThu,
      startTimeFri,
      endTimeFri,
      startTimeSat,
      endTimeSat,
      alias,
      iconImage,
      avatarImage,
      militaryTime,
      additionalAttendees,
      startCrement,
      defaultTime,
      language,
      sundayStart
    } = this.state.schedule
    const { allCalendars, filteredDestinationCalendars } = this.state

    const sourceCal = allCalendars[+source]

    console.log(filteredDestinationCalendars)
    const moreCals = others.map((e) => {
      console.log(e)
      var cal = filteredDestinationCalendars.find(cal => cal.id == e)
      console.log(cal)
      return {
        id: cal.id,
        calendarAccountId: cal.calendarAccountId,
        type: cal.calendarAccountType,
      }
    })
    // startHourMon: startTimeMon.get('hour'),
    //   endHourMon: endTimeMon.get('hour'),
    //   startMinMon: startTimeMon.get('minute'),
    //   endMinMon: endTimeMon.get('minute'),
    var timeMatrix = {
      Mon: {
        startHour: startTimeMon.get('hour'),
        endHour: endTimeMon.get('hour'),
        startMin: startTimeMon.get('minute'),
        endMin: endTimeMon.get('minute'),
      },
      Tue: {
        startHour: startTimeTue.get('hour'),
        endHour: endTimeTue.get('hour'),
        startMin: startTimeTue.get('minute'),
        endMin: endTimeTue.get('minute'),
      },
      Wed: {
        startHour: startTimeWed.get('hour'),
        endHour: endTimeWed.get('hour'),
        startMin: startTimeWed.get('minute'),
        endMin: endTimeWed.get('minute'),
      },
      Thu: {
        startHour: startTimeThu.get('hour'),
        endHour: endTimeThu.get('hour'),
        startMin: startTimeThu.get('minute'),
        endMin: endTimeThu.get('minute'),
      },
      Fri: {
        startHour: startTimeFri.get('hour'),
        endHour: endTimeFri.get('hour'),
        startMin: startTimeFri.get('minute'),
        endMin: endTimeFri.get('minute'),
      },
      Sat: {
        startHour: startTimeSat.get('hour'),
        endHour: endTimeSat.get('hour'),
        startMin: startTimeSat.get('minute'),
        endMin: endTimeSat.get('minute'),
      },
      Sun: {
        startHour: startTimeSun.get('hour'),
        endHour: endTimeSun.get('hour'),
        startMin: startTimeSun.get('minute'),
        endMin: endTimeSun.get('minute'),
      },
    }

    // console.log({
    //   id: this.props.id || undefined,
    //   sourceCalendarId: sourceCal.id,
    //   sourceAccountId: sourceCal.calendarAccountId,
    //   displayName: `${
    //     sourceCal.name || sourceCal.summary
    //   } - ${meetingIncrement} mins`,
    //   type: sourceCal.calendarAccountType,
    //   dayOptions: days.join(',').toLocaleLowerCase(),
    //   meetingIncrement,
    //   bodyTemplate: bodyTemplate.replace(/(?:\r\n|\r|\n)/g, '<br/>'),
    //   startHour: startTime.get('hour'),
    //   endHour: endTime.get('hour'),
    //   startMin: startTime.get('minute'),
    //   endMin: endTime.get('minute'),
    //   tz: timezone,
    //   destinationColor: destinationColor ? destinationColor : 'default',
    //   dayRange: dayRange,
    //   others: moreCals,
    //   greeting,
    //   label,
    //   questions,
    //   bufferBefore,
    //   bufferAfter,
    //   leadTime,
    //   meeting: meeting,
    //   integrations,
    //   timeMatrix,
    //   alias,
    //   iconImage,
    // avatarImage,
    //   ownerName: sourceCal.name || sourceCal.summary,
    //   ownerEmail: sourceCal.email
    // })

    return {
      id: this.props.id || undefined,
      sourceCalendarId: sourceCal.id,
      sourceAccountId: sourceCal.calendarAccountId,
      type: sourceCal.calendarAccountType,
      displayName: `${
        sourceCal.name || sourceCal.summary
      } - ${meetingIncrement} mins`,
      dayOptions: this.getOrderedDayOptions(),
      meetingIncrement,
      bodyTemplate: bodyTemplate.replace(/(?:\r\n|\r|\n)/g, '<br/>'),
      startHour: startTime.get('hour'),
      endHour: endTime.get('hour'),
      startMin: startTime.get('minute'),
      endMin: endTime.get('minute'),
      tz: timezone,
      destinationColor: destinationColor ? destinationColor : 'default',
      dayRange: dayRange,
      others: moreCals,
      greeting,
      label,
      questions,
      bufferBefore: parseInt(bufferBefore),
      bufferAfter: parseInt(bufferAfter),
      leadTime: parseInt(leadTime),
      meeting: meeting,
      integrations,
      timeMatrix,
      alias,
      iconImage,
      avatarImage,
      ownerName: sourceCal.name || sourceCal.summary,
      ownerEmail: sourceCal.email,
      militaryTime,
      additionalAttendees: additionalAttendees.join(','),
      startCrement: startCrement,
      defaultTime,
      language,
      sundayStart
    }
  }

  getOrderedDayOptions = () => {
    const { days } = this.state.schedule
    const activeDays = reduce(
      daysOfWeek,
      (acc, day) => (days.includes(day) ? [...acc, day] : acc),
      []
    )
    return activeDays.join(',').toLocaleLowerCase()
  }

  submitSync = async (redirect = 'normal') => {
    const {
      source,
      startTime,
      endTime,
      days,
      meetingIncrement,
      bodyTemplate,
      timezone,
      destinationColor,
      dayRange,
      others,
      greeting,
      label,
      questions,
      bufferBefore,
      bufferAfter,
      leadTime,
      meeting,
      integrations,
      startTimeSun,
      endTimeSun,
      startTimeMon,
      endTimeMon,
      startTimeTue,
      endTimeTue,
      startTimeWed,
      endTimeWed,
      startTimeThu,
      endTimeThu,
      startTimeFri,
      endTimeFri,
      startTimeSat,
      endTimeSat,
      alias,
      iconImage,
      avatarImage,
      militaryTime,
      customSubject,
      additionalAttendees,
      startCrement,
      defaultTime,
      sundayStart,
      language
    } = this.state.schedule
    const { t } = this.props; // Destructure t from props
    if (meetingIncrement.length == 0) {
      this.setState({
        isLoading: false,
        meetingLengthError: this.props.t('scheduler.error_meeting_length_required') // Set error state instead of alert
      })
      // alert(t('scheduler.error_meeting_length_required')) // Removed alert
      return
    } else {
      // Clear error if validation passes
      if (this.state.meetingLengthError) {
        this.setState({ meetingLengthError: null });
      }
      const { allCalendars, readTooCalendars } = this.state // Use readTooCalendars for lookup

      const sourceCal = allCalendars[+source]

      // Map selected IDs back to calendar objects for the API
      const moreCals = others.map((selectedId) => {
        // Find the full calendar object from the original list using the ID
        var cal = readTooCalendars.find(c => c.id === selectedId);
        // Handle case where calendar might somehow be missing (though previous checks should prevent this)
        if (!cal) return null;
        return {
          id: cal.id,
          calendarAccountId: cal.calendarAccountId,
          type: cal.calendarAccountType,
        }
      }).filter(Boolean); // Filter out any nulls if a calendar was missing
      // startHourMon: startTimeMon.get('hour'),
      //   endHourMon: endTimeMon.get('hour'),
      //   startMinMon: startTimeMon.get('minute'),
      //   endMinMon: endTimeMon.get('minute'),
      var timeMatrix = {
        Mon: {
          startHour: startTimeMon.get('hour'),
          endHour: endTimeMon.get('hour'),
          startMin: startTimeMon.get('minute'),
          endMin: endTimeMon.get('minute'),
        },
        Tue: {
          startHour: startTimeTue.get('hour'),
          endHour: endTimeTue.get('hour'),
          startMin: startTimeTue.get('minute'),
          endMin: endTimeTue.get('minute'),
        },
        Wed: {
          startHour: startTimeWed.get('hour'),
          endHour: endTimeWed.get('hour'),
          startMin: startTimeWed.get('minute'),
          endMin: endTimeWed.get('minute'),
        },
        Thu: {
          startHour: startTimeThu.get('hour'),
          endHour: endTimeThu.get('hour'),
          startMin: startTimeThu.get('minute'),
          endMin: endTimeThu.get('minute'),
        },
        Fri: {
          startHour: startTimeFri.get('hour'),
          endHour: endTimeFri.get('hour'),
          startMin: startTimeFri.get('minute'),
          endMin: endTimeFri.get('minute'),
        },
        Sat: {
          startHour: startTimeSat.get('hour'),
          endHour: endTimeSat.get('hour'),
          startMin: startTimeSat.get('minute'),
          endMin: endTimeSat.get('minute'),
        },
        Sun: {
          startHour: startTimeSun.get('hour'),
          endHour: endTimeSun.get('hour'),
          startMin: startTimeSun.get('minute'),
          endMin: endTimeSun.get('minute'),
        },
      }

      // console.log({
      //   id: this.props.id || undefined,
      //   sourceCalendarId: sourceCal.id,
      //   sourceAccountId: sourceCal.calendarAccountId,
      //   displayName: `${
      //     sourceCal.name || sourceCal.summary
      //   } - ${meetingIncrement} mins`,
      //   type: sourceCal.calendarAccountType,
      //   dayOptions: days.join(',').toLocaleLowerCase(),
      //   meetingIncrement,
      //   bodyTemplate: bodyTemplate.replace(/(?:\r\n|\r|\n)/g, '<br/>'),
      //   startHour: startTime.get('hour'),
      //   endHour: endTime.get('hour'),
      //   startMin: startTime.get('minute'),
      //   endMin: endTime.get('minute'),
      //   tz: timezone,
      //   destinationColor: destinationColor ? destinationColor : 'default',
      //   dayRange: dayRange,
      //   others: moreCals,
      //   greeting,
      //   label,
      //   questions,
      //   bufferBefore,
      //   bufferAfter,
      //   leadTime,
      //   meeting: meeting,
      //   integrations,
      //   timeMatrix,
      //   alias,
      // })

      await API.post('schedules', '/schedules', {
        body: {
          id: this.props.id || undefined,
          sourceCalendarId: sourceCal.id,
          sourceAccountId: sourceCal.calendarAccountId,
          displayName: `${
            sourceCal.name || sourceCal.summary
          } - ${meetingIncrement} mins`,
          type: sourceCal.calendarAccountType,
          dayOptions: days.join(',').toLocaleLowerCase(),
          meetingIncrement,
          bodyTemplate: bodyTemplate.replace(/(?:\r\n|\r|\n)/g, '<br/>'),
          startHour: startTime.get('hour'),
          endHour: endTime.get('hour'),
          startMin: startTime.get('minute'),
          endMin: endTime.get('minute'),
          tz: timezone,
          destinationColor: destinationColor ? destinationColor : 'default',
          dayRange: dayRange,
          others: moreCals,
          greeting,
          label,
          questions,
          bufferBefore: parseInt(bufferBefore),
          bufferAfter: parseInt(bufferAfter),
          leadTime: parseInt(leadTime),
          meeting: meeting,
          integrations,
          timeMatrix,
          alias,
          iconImage,
          avatarImage,
          militaryTime,
          customSubject,
          additionalAttendees: additionalAttendees.join(','),
          startCrement,
          defaultTime,
          sundayStart,
          language
        },
      })
      if (redirect != 'zoom') {
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          event: 'dashboardEvent',
          category: 'userActivity',
          action: 'createScheduler',
          label: this.props.license.userId,
          email: this.props.license.email,
        })

        // navigate('/dashboard/schedules/')
        window.location.href = window.location.origin + '/dashboard/schedules/'
      } else {
        window.location =
          'https://zoom.us/oauth/authorize?response_type=code&client_id=' +
          process.env.REACT_OAUTH_ZOOM_CLIENT +
          '&redirect_uri=' +
          encodeURIComponent(process.env.REACT_APP_OAUTH_REDIRECT_URL + '/dashboard/zoom/')
      }
    }
  }

  nextPage = () => {
    const { page, lastPage } = this.state
    if (page === lastPage) {
      this.setState({ isLoading: false, showModal: true })

      return
    } else {
      this.setState({
        page: this.state.page + 1,
      })
      window.scrollTo(0, 0)
    }
  }

  changePage = (page) => {
    this.setState({ page })
  }

  changeScheduleValue = (field, value) => {
    //  console.log(field, value)
    var changeColor = false
    if (field == 'source') {
      changeColor = true
    }

    this.setState(
      {
        schedule: {
          ...this.state.schedule,
          [field]: value,
        },
      },
      () => {
        // console.log("CHANGE " + field)
        // console.log(this.state.schedule)
        if (
          this.state.existingScheduleId != null &&
          this.state.existingScheduleId != ''
        ) {
          this.setState({
            quickSave: true,
          })
        }
        if (changeColor) {
          this.changeScheduleValue('destinationColor', 'default')
        }

        if (field == 'meetingIncrement') {
          if (this.state.schedule.meetingIncrement.length != 0) {
            this.setState({ meetingError: '' })
          }
          if (this.state.schedule.meetingIncrement.length == 0) {
            this.changeScheduleValue('defaultTime', '-1')
            this.setState({ meetingError: 'Error' })
          } else if (
            this.state.schedule.meetingIncrement.indexOf(
              '' + this.state.schedule.defaultTime
            ) == -1
          ) {
            this.changeScheduleValue(
              'defaultTime',
              this.state.schedule.meetingIncrement[0]
            )
          }
        }
      }
    )
  }

  SourceForm = () => {
    const { t } = this.props; // Destructure t from props
    return (
      <>
        <CBHeader
          step={1}
          label={this.props.t('sync.select_calendars')} // Reusing sync key
          buttonLabel={this.props.t('scheduler.cancel_scheduler')}
          buttonIcon={<Edit></Edit>}
          buttonAction={(e) => {
            this.props.navigate('/dashboard/schedules/')
          }}
        ></CBHeader>
        {this.props.license.userId != null &&
          this.props.accounts.length == 0 && (
            <center className="mt-8 mb-8 text-lg">
              <a
                onClick={(e) => {
                  this.props.navigate('/dashboard/accounts/new')
                }}
              >
                {this.props.t('scheduler.add_calendar_account')}
              </a>
            </center>
          )}

        <CBHeader label={this.props.t('scheduler.select_booking_calendar')} subHeader={true} />

        <div className="mb-2">
          {this.props.t('scheduler.select_booking_calendar_description')}
        </div>
        <div>
          {/* Replaced Ant Design Select with CBSelect */}
          <CBSelect
            key={`source-select-${this.state.existingScheduleId || 'new'}`} // Added key
            style={{ width: '100%' }}
            // className="bg-neutral_3" // CBSelect uses default styling
            // size="large" // CBSelect uses default styling
            // placeholder={this.props.t('scheduler.select_calendar_placeholder')} // Handled by adding a default option
            // showSearch // Not supported by CBSelect
            // optionFilterProp="children" // Not supported by CBSelect
            // autoFocus // Not supported by CBSelect
            onChange={(v) => {
              // CBSelect returns the value directly, which is the index 'i' here
              this.changeScheduleValue('source', parseInt(v)) // Ensure value is integer index
            }}
            selected={this.state.schedule.source} // Pass the selected index
            labels={[
              this.props.t('scheduler.select_calendar_placeholder'), // Placeholder option
              ...(this.state.schedule.source === -1 && this.state.otherError ? [this.props.t('scheduler.missing_calendar')] : []), // Missing calendar option if needed
              ...this.state.allCalendars.map(c =>
                `${c.name || c.summary} (${this.props.accounts.find(a => a.calendarAccountId === c.calendarAccountId)?.email || 'N/A'})` // Simplified label
              )
            ]}
            values={[
              undefined, // Placeholder value
              ...(this.state.schedule.source === -1 && this.state.otherError ? [-1] : []), // Missing calendar value
              ...this.state.allCalendars.map((c, i) => i) // Values are the indices
            ]}
          />
          {this.state.schedule.source == -1 &&
            this.state.otherError &&
            this.state.otherError != '' && (
              <CBAlert
                type="error"
              >
                {this.props.t('scheduler.error_prefix') + this.state.otherError}
              </CBAlert>
            )}

          <div className="mb-4"></div>
          <CBListItem
            borderLight={true}
            onClick={(e) => {
              this.props.navigate('/dashboard/accounts/new')
            }}
          >
            {this.props.t('sync.calendar_not_showing')}{' '} {/* Reusing sync key */}
            <Link to="/dashboard/accounts/new">{this.props.t('sync.add_another_account_link')}</Link>. {/* Reusing sync key */}
          </CBListItem>
        </div>

        <div className="title_label">
          {this.props.t('scheduler.check_availability_description')}
        </div>
              
        {/* Replaced Ant Design Select (multiple) with CBMultiSelect */}
        <CBMultiSelect
          key={`others-select-${this.state.existingScheduleId || 'new'}`} // Changed key
          // size="large" // Not applicable
          placeholder={this.props.t('scheduler.select_calendar_placeholder')}
          // showSearch // Not supported
          // optionFilterProp="children" // Not supported
          className="mt-4" // Added margin from original style
          onChange={(selectedIds) => { // Parameter is now an array of IDs
            // Limit selection to 3
            
            if (selectedIds.length < 4) {
              this.changeScheduleValue('others', selectedIds) // Pass IDs directly
            }
            // TODO: Add user feedback if they try to select more than 3
          }}
          selectedValues={this.state.schedule.others}
          options={[
            // Add missing calendar option if needed
            ...(this.state.schedule.others.includes(-1) && this.state.otherError ? [{ label: this.props.t('scheduler.missing_calendar'), value: -1 }] : []),
            // Map calendars to options format
            ...this.state.filteredDestinationCalendars.map((c, i) => ({
              label: `${c.name || c.summary} (${this.props.accounts.find(a => a.calendarAccountId === c.calendarAccountId)?.email || 'N/A'})`, // Simplified label
              value: c.id // Value is the calendar ID
            }))
          ]}
        />

        {this.state.schedule.others.includes(-1) &&
          this.state.otherError &&
          this.state.otherError != '' && (
            <CBAlert
              type="error"
            >
              {this.props.t('scheduler.error_prefix') + this.state.otherError}
            </CBAlert>
          )}
        {this.props.license.vanityAlias &&
          this.props.license.vanityAlias != '' && (
            <>
              <div className="mt-8">{this.props.t('scheduler.set_custom_url_path')}</div>

              {this.state.schedule.alias != '__me__' && (
                <CBUrlField
                  hint={this.props.t('scheduler.url_alias_hint')}
                  maxLength={25}
                  value={this.state.schedule.alias}
                  style={{ width: 450 }}
                  onChange={(e) => {
                    var name = e.toLowerCase()
                    var usernameRegex = /^[a-zA-Z0-9-_]+$/

                    if (name.match(usernameRegex)) {
                      this.changeScheduleValue('alias', name)
                      var test = this.props.schedules.filter(
                        (sched) =>
                          sched.id != this.props.id && sched.alias == name
                      )
                      if (test.length > 0) {
                        this.setState({
                          pathError: this.props.t('scheduler.error_path_in_use'),
                        })
                      } else {
                        this.setState({ pathError: null })
                      }
                    } else if (name == '') {
                      this.changeScheduleValue('alias', '')
                      this.setState({ pathError: null })
                    }
                  }}
                  label={
                    window.location.origin +
                    '/book/' +
                    this.props.license.vanityAlias +
                    '/'
                  }
                ></CBUrlField>
              )}
              {this.state.schedule.alias == '__me__' && (
                <CBUrlField
                  disabled={true}
                  label={
                    window.location.origin +
                    '/book/' +
                    this.props.license.vanityAlias +
                    '/'
                  }
                ></CBUrlField>
              )}
              <div>
                <CBCheckItem
                  label={
                    <div className="font-sarabun">
                      {this.props.t('scheduler.set_default_path_label')}{' '}
                      <code
                        className="bg-gray-200 text-red-600 px-1 rounded"
                      >{`/book/${this.props.license.vanityAlias}/`}</code>
                    </div>
                  }
                  checked={this.state.schedule.alias == '__me__'}
                  onChange={(e) => {
                    if (e) {
                      this.changeScheduleValue('alias', '__me__')
                      var test = this.props.schedules.filter(
                        (sched) =>
                          sched.id != this.props.id && sched.alias == '__me__'
                      )
                      if (test.length > 0) {
                        this.setState({
                          pathError: this.props.t('scheduler.error_default_path_in_use'),
                        })
                      } else {
                        this.setState({ pathError: null })
                      }
                    } else {
                      this.changeScheduleValue('alias', '')
                      this.setState({ pathError: null })
                    }
                  }}
                ></CBCheckItem>
                {this.state.pathError && (
                  <div className="text-red-500 mt-1">
                    {this.state.pathError}
                  </div>
                )}
              </div>
            </>
          )}

        <div className="title_label">
          {this.props.t('scheduler.scheduler_name_description')}
        </div>
        <div>
          {this.state.existingScheduleId != null && (
            <CBInput
              maxLength={100}
              hint={this.props.t('scheduler.scheduler_name_hint')}
              value={this.state.schedule.label}
              onChange={(e) => this.changeScheduleValue('label', e)}
            ></CBInput>
          )}
          {this.state.existingScheduleId == null && (
            <CBInput
              maxLength={100}
              hint={this.props.t('scheduler.scheduler_name_hint')}
              value={this.state.schedule.label}
              onChange={(e) => this.changeScheduleValue('label', e)}
            ></CBInput>
          )}
        </div>
        <h4 className="pt-4 pb-4 font-semibold">{this.props.t('scheduler.customize_link_appearance_header')}</h4>
        <div>
          <div>
            {this.props.t('scheduler.customize_welcome_text_description')}
          </div>
          <div style={{ marginTop: 16 }}>
            {this.state.existingScheduleId != null && (
              <CBInput
                maxLength={100}
                hint={this.props.t('scheduler.welcome_text_hint')}
                value={this.state.schedule.greeting}
                onChange={(e) => this.changeScheduleValue('greeting', e)}
              ></CBInput>
            )}

            {this.state.existingScheduleId == null && (
              <CBInput
                maxLength={100}
                hint={this.props.t('scheduler.welcome_text_hint')}
                value={this.state.schedule.greeting}
                onChange={(e) => this.changeScheduleValue('greeting', e)}
              ></CBInput>
            )}
            <div>
             <div className="mb-8">
          <div className="pt-6 pb-4 font-sarabun">{this.props.t('scheduler.language_label')}</div>
        {/* Replaced Ant Design Select with CBSelect */}
        <CBSelect
            style={{ width: 200 }}
            selected={this.state.schedule.language}
            onChange={(v) => this.changeScheduleValue('language', v)}
            labels={[
              this.props.t('scheduler.lang_en'),
              this.props.t('scheduler.lang_es'),
              this.props.t('scheduler.lang_de'),
              this.props.t('scheduler.lang_fr'),
              this.props.t('scheduler.lang_pt'),
              this.props.t('scheduler.lang_ja'),
              this.props.t('scheduler.lang_default')
            ]}
            values={['en', 'es', 'de', 'fr', 'pt', 'ja', 'default']}
          />

          {this.state.schedule.language != "en" && <div className="pt-4">{this.props.t('scheduler.custom_text_not_translated_warning')}</div>}

        </div>
        <div>
          <CBRadioGroup
            center={false}
            title={this.props.t('scheduler.time_format_label')}
            selected={this.state.schedule.militaryTime ? 1 : 0}
            labels={[this.props.t('scheduler.time_format_12h'), this.props.t('scheduler.time_format_24h')]}
            values={[false, true]}
            onChange={(e) => {
              this.changeScheduleValue('militaryTime', e == 0 ? false : true)
            }}
          ></CBRadioGroup>
        </div>
        <div>
          <CBRadioGroup
            center={false}
            title={this.props.t('scheduler.first_day_of_week_label')}
            selected={this.state.schedule.sundayStart ? 0 : 1}
            labels={[this.props.t('scheduler.day_sun'), this.props.t('scheduler.day_mon')]}
            values={[true, false]}
            onChange={(e) => {
              this.changeScheduleValue('sundayStart', e == 0 ? true : false)
            }}
          ></CBRadioGroup>
        </div>
            {/* {this.state.schedule.greeting && <CBInput
              maxLength={100}
              hint={'Find Time To Book With ...'}
              value={this.state.schedule.greeting}
              onChange={(e) => this.changeScheduleValue('greeting', e)}
            ></CBInput>} */}
            <ScheduleImageUpload
              iconImage={this.state.schedule.iconImage}
              avatarImage={this.state.schedule.avatarImage}
              setIconImage={(img) => {
                this.changeScheduleValue('iconImage', img)
              }}
              setAvatarImage={(img) => {
                this.changeScheduleValue('avatarImage', img)
              }}
            />
          </div>
          </div>
        </div>
      </>
    )
  }

  changeTimezone = (tz) => {
    this.setState({
      schedule: {
        ...this.state.schedule,
        timezone: tz,
      },
    })
  }

  DateRangeForm = () => {
    const { t } = this.props; // Destructure t from props
    const [minArray, setMinArray] = useState(this.state.minArray)
    const [addTimeVisible, setAddTimeVisible] = useState(false)
    const [showAdvance, setShowAdvance] = useState(false)
    const [addTimeValue, setAddTimeValue] = useState(undefined)

    const options = moment.tz.names().map((tz) => (
      <CBSelect.Option key={tz} style={{ 'font-family': 'sarabun' }}>
        {tz} ({moment.tz(this.state.currentDate, tz).format('Z z')})
      </CBSelect.Option>
    ))
    return (
      <>
        <CBHeader
          step={2}
          label={this.props.t('scheduler.availability_header')}
          buttonLabel={this.props.t('sync.edit_previous_step')} // Reusing sync key
          buttonIcon={<Up></Up>}
          buttonAction={(e) => {
            this.setState({ page: this.state.page - 1 })
          }}
        ></CBHeader>

        <div>
          <div className="title_label">
            {this.props.t('scheduler.select_meeting_length_description')}
          </div>

          <div // Replaced Paragraph
            style={{ marginLeft: 16, marginTop: 40, marginBottom: 40 }}
          >
            {/* Replaced Checkbox.Group with CBCheckbox mapping */}
            <div className="flex flex-wrap gap-4"> {/* Added container for checkboxes */}
              {minArray.map((timeValue) => (
                <CBCheckbox
                  key={timeValue}
                  label={`${timeValue} ${this.props.t('common.minutes_short', { count: parseInt(timeValue) })}`} // Assuming 'common.minutes_short' key exists
                  value={timeValue}
                  checked={this.state.schedule.meetingIncrement.includes(timeValue)}
                  onChange={(isChecked, val) => {
                    const currentIncrements = this.state.schedule.meetingIncrement;
                    let newIncrements;
                    if (isChecked) {
                      newIncrements = [...currentIncrements, val].sort((a, b) => parseInt(a) - parseInt(b));
                    } else {
                      newIncrements = currentIncrements.filter(inc => inc !== val);
                    }
                    this.changeScheduleValue('meetingIncrement', newIncrements);
                  }}
                />
              ))}
            </div>
            {this.state.meetingError && this.state.meetingError != '' && (
              <div className="mt-2 text-red-500">
                {this.props.t('scheduler.error_meeting_length_required')}
              </div>
            )}
            <a
              className="flex flex-row items-center gap-x-2 underline mt-4 mb-2 text-darkblue_highlight cursor-pointer"
              onClick={(e) => {
                setAddTimeVisible(!addTimeVisible)
              }}
            >
              {' '}
              {addTimeVisible ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-4 h-4"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M19.5 8.25l-7.5 7.5-7.5-7.5"
                  />
                </svg>
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-4 h-4"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M8.25 4.5l7.5 7.5-7.5 7.5"
                  />
                </svg>
              )}
              {addTimeVisible ? t('common.hide') : t('scheduler.add_custom_time')}
            </a>
            {addTimeVisible && <div
              hidden={!addTimeVisible}
              className="flex flex-row gap-x-4 mt-2 items-center"
            >
              <div className="w-1/4">
                <CBInput
                  id="addTime"
                  onChange={(e) => {
                    setAddTimeValue(
                      e.replaceAll('-', '').split('.')[0]
                    )
                  }}
                  value={addTimeValue}
                  type="number"
                  step="1"
                  min="5"
                  max="480"
                ></CBInput>
              </div>

              {/* Replaced Ant Design Button with CBButton */}
              <CBButton
                disabled={!addTimeValue || addTimeValue == ''}
                onClick={(e) => {
                  var add = '' + addTimeValue
                  if (!minArray.includes(add)) {
                    var arr = [...minArray, add]
                    setMinArray(arr)
                    setAddTimeValue(undefined)
                    setAddTimeVisible(false)
                  }
                }}
              >
                {this.props.t('common.add_button')}
              </CBButton> {/* Fixed closing tag */}
            </div>}
            <div>
              <CBRadioGroup
                center={false}
                title={this.props.t('scheduler.default_time_description')}
                labels={this.state.schedule.meetingIncrement}
                values={this.state.schedule.meetingIncrement}
                selected={this.state.schedule.meetingIncrement.indexOf(
                  '' + this.state.schedule.defaultTime
                )}
                onChange={(v) => {
                  this.changeScheduleValue(
                    'defaultTime',
                    this.state.schedule.meetingIncrement[v]
                  )
                }}
              />
            </div>
            {/* <Input id="incr" onChange={e=>setStartCrement(e.target.value)} value={startCrement} type="number" min="5" max="480"></Input>
             
            <Button onClick={e=>{
              this.changeScheduleValue('startCrement', startCrement)
            }}>Set</Button> */}
          </div> {/* /Replaced Paragraph */}
        </div>

        <div className="mb-4">
          <div className="title_label">
            {this.props.t('scheduler.select_days_times_description')}
          </div>

          <div>
            {daysOfWeek.map((day) => {
              const active = this.state.schedule.days.includes(day)
              return (
                <div className="mb-2">
                  <div>
                    <CBCheckItem
                      label={day}
                      key={day}
                      onChange={(e) => {
                        var days = this.state.schedule.days

                        if (e) {
                          if (!days.includes(day)) {
                            days.push(day)
                            this.changeScheduleValue('days', days)
                          }
                        } else {
                          if (days.includes(day)) {
                            this.changeScheduleValue(
                              'days',
                              days.filter((d) => d != day)
                            )
                          }
                        }
                      }}
                      style={{ width: 75 }}
                      checked={active}
                    ></CBCheckItem>
                  </div>

                  {active && (
                    <div className="mt-2 mb-2 flex justify-center items-center gap-x-4">
                      {/* Replaced Ant Design TimePicker with CBTimePicker */}
                      <CBCustomTimePicker
                        // style // Use default styling
                        // className // Use default styling
                        disabled={!active}
                        militaryTime={this.state.schedule.militaryTime} // Pass military time preference
                        // placeholder // Handled internally
                        // size="large" // Use default styling
                        // format // Handled internally
                        // allowClear={false} // Handled internally by Cancel button
                        // inputReadOnly // Handled internally
                        value={(this.state.schedule['startTime' + day] || this.state.schedule.startTime)?.format('HH:mm')} // Format moment object to HH:mm string
                        onChange={(timeString) => { // timeString is "HH:mm"
                          const newTime = moment(timeString, 'HH:mm');
                          if (newTime.isValid()) {
                            this.changeScheduleValue('startTime' + day, newTime);
                          }
                        }}
                      />
                      {this.props.t('scheduler.time_range_separator')}
                      {/* Replaced Ant Design TimePicker with CBTimePicker */}
                      <CBCustomTimePicker
                        // style // Use default styling
                        disabled={!active}
                        militaryTime={this.state.schedule.militaryTime} // Pass military time preference
                        // size="large" // Use default styling
                        // placeholder // Handled internally
                        // format // Handled internally
                        // allowClear={false} // Handled internally by Cancel button
                        // inputReadOnly // Handled internally
                        value={(this.state.schedule['endTime' + day] || this.state.schedule.endTime)?.format('HH:mm')} // Format moment object to HH:mm string
                        onChange={(timeString) => { // timeString is "HH:mm"
                          const newTime = moment(timeString, 'HH:mm');
                          if (newTime.isValid()) {
                            this.changeScheduleValue('endTime' + day, newTime);
                          }
                        }}
                      />
                    </div>
                  )}
                </div>
              )
            })}
            <div className="mb-4">
              <div className="title_label">{this.props.t('scheduler.timezone_label')}</div>
              {/* Replaced Ant Design Select with CBSelect - Search functionality lost */}
              <CBSelect
                style={{ width: 280 }} // Applied width from original Select
                selected={this.state.schedule.timezone}
                onChange={this.changeTimezone} // CBSelect passes value directly
                labels={[
                  t('sync.select_timezone_placeholder'), // Placeholder option
                  ...moment.tz.names().map(tz => `${tz} (${moment.tz(this.state.currentDate, tz).format('Z z')})`)
                ]}
                values={[
                  undefined, // Placeholder value
                  ...moment.tz.names()
                ]}
              />
            </div>
          </div>
        </div>

        <div>
          <div className="title_label">
            {this.props.t('scheduler.booking_advance_notice_question')}
          </div>

          {/* Replaced Ant Design Select with CBSelect */}
          <CBSelect
            style={{ width: 200 }}
            selected={this.state.schedule.dayRange} // Use selected instead of defaultValue
            onChange={(v) => this.changeScheduleValue('dayRange', v)}
            labels={[
              t('scheduler.duration_1_week'),
              t('scheduler.duration_2_weeks'),
              t('scheduler.duration_3_weeks'),
              t('scheduler.duration_1_month'),
              t('scheduler.duration_2_months'),
              t('scheduler.duration_3_months'),
              t('scheduler.duration_4_months'),
              t('scheduler.duration_5_months'),
              t('scheduler.duration_6_months'),
              t('scheduler.duration_8_months'),
              t('scheduler.duration_10_months'),
              t('scheduler.duration_1_year')
            ]}
            values={['7', '14', '21', '30', '60', '90', '120', '150', '180', '240', '300', '365']}
          />

          <div className="title_label">
            {this.props.t('scheduler.lead_time_question')}
          </div>
          {/* Replaced Ant Design Select with CBSelect */}
          <CBSelect
            key="leadtime"
            style={{ width: 200 }}
            selected={`${this.state.schedule.leadTime}`} // Use selected, ensure value is string
            onChange={(v) => this.changeScheduleValue('leadTime', v)} // CBSelect passes value directly
            labels={[
              t('scheduler.lead_time_0_min'),
              t('scheduler.lead_time_5_min'),
              t('scheduler.lead_time_10_min'),
              t('scheduler.lead_time_15_min'),
              t('scheduler.lead_time_30_min'),
              t('scheduler.lead_time_45_min'),
              t('scheduler.lead_time_1_hour'),
              t('scheduler.lead_time_90_min'),
              t('scheduler.lead_time_2_hours'),
              t('scheduler.lead_time_3_hours'),
              t('scheduler.lead_time_4_hours'),
              t('scheduler.lead_time_8_hours'),
              t('scheduler.lead_time_12_hours'),
              t('scheduler.lead_time_24_hours'),
              t('scheduler.lead_time_48_hours'),
              t('scheduler.lead_time_3_days'),
              t('scheduler.lead_time_duration_1_week')
            ]}
            values={['0', '5', '10', '15', '30', '45', '60', '90', '120', '180', '240', '480', '720', '1440', '2880', '4320', '10080']}
          />
        </div>

        <div className="mt-2">
          <a
            className="flex flex-row items-center gap-x-2 underline mt-8 mb-4 lg:mb-0 text-darkblue_highlight text-lg"
            onClick={(e) => {
              setShowAdvance(!showAdvance)
            }}
          >
            {showAdvance ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-4 h-4"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M19.5 8.25l-7.5 7.5-7.5-7.5"
                />
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-4 h-4"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M8.25 4.5l7.5 7.5-7.5 7.5"
                />
              </svg>
            )}{' '}
            {showAdvance ? t('common.hide') : t('common.show')} {this.props.t('sync.advanced')} {/* Reusing keys */}
          </a>
          <div hidden={!showAdvance}>
            <div className="title_label">{this.props.t('scheduler.buffer_before_label')}</div>
            {/* Replaced Ant Design Select with CBSelect */}
            <CBSelect
              key="before"
              style={{ width: 200 }}
              selected={`${this.state.schedule.bufferBefore}`} // Use selected, ensure value is string
              onChange={(v) => this.changeScheduleValue('bufferBefore', v)}
              labels={[
                t('scheduler.lead_time_0_min'),
                t('scheduler.lead_time_5_min'),
                t('scheduler.lead_time_10_min'),
                t('scheduler.lead_time_15_min'),
                t('scheduler.lead_time_30_min'),
                t('scheduler.lead_time_45_min'),
                t('scheduler.lead_time_1_hour'),
                t('scheduler.lead_time_90_min'),
                t('scheduler.lead_time_2_hours'),
                t('scheduler.lead_time_3_hours'),
                t('scheduler.lead_time_4_hours')
              ]}
              values={['0', '5', '10', '15', '30', '45', '60', '90', '120', '180', '240']}
            />
            <div className="mb-8 ">
              <div className="title_label">{this.props.t('scheduler.buffer_after_label')}</div>

              {/* Replaced Ant Design Select with CBSelect */}
              <CBSelect
                key="after"
                style={{ width: 200 }}
                selected={`${this.state.schedule.bufferAfter}`} // Use selected, ensure value is string
                onChange={(v) => this.changeScheduleValue('bufferAfter', v)}
                labels={[
                  t('scheduler.lead_time_0_min'),
                  t('scheduler.lead_time_5_min'),
                  t('scheduler.lead_time_10_min'),
                  t('scheduler.lead_time_15_min'),
                  t('scheduler.lead_time_30_min'),
                  t('scheduler.lead_time_45_min'),
                  t('scheduler.lead_time_1_hour'),
                  t('scheduler.lead_time_90_min'),
                  t('scheduler.lead_time_2_hours'),
                  t('scheduler.lead_time_3_hours'),
                  t('scheduler.lead_time_4_hours')
                ]}
                values={['0', '5', '10', '15', '30', '45', '60', '90', '120', '180', '240']}
              />
            </div>

            <div className="title_label">{this.props.t('scheduler.start_increments_label')}</div>

            <div className="flex flex-row gap-x-4 mt-2 mb-4">
              <div className="w-1/4">
                {/* Replaced Ant Design Select with CBSelect */}
                <CBSelect
                  style={{ width: 200 }}
                  selected={`${this.state.schedule.startCrement}`} // Use selected, ensure value is string
                  onChange={(v) =>
                    this.changeScheduleValue('startCrement', parseInt(v)) // CBSelect passes value directly
                  }
                  labels={[
                    t('scheduler.start_increments_default'),
                    t('scheduler.start_increments_5_min'),
                    t('scheduler.start_increments_10_min'),
                    t('scheduler.start_increments_15_min'),
                    t('scheduler.start_increments_20_min'),
                    t('scheduler.start_increments_30_min'),
                    t('scheduler.start_increments_40_min'),
                    t('scheduler.start_increments_50_min'),
                    t('scheduler.start_increments_60_min')
                  ]}
                  values={['0', '5', '10', '15', '20', '30', '40', '50', '60']}
                />
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }

  // This function seems unused or redundant based on DateRangeForm, removing content
  EventDetailForm = () => {
    const { t } = this.props; // Destructure t from props
    return (
      <>
        {/* <h2 className="text-center">{this.props.t('scheduler.meeting_length_header')}</h2>

        <h3 className="text-center">
          {this.props.t('scheduler.select_meeting_length_description')}
        </h3>

        <div style={{ marginTop: 40, marginBottom: 40 }}> */}
          {/* <CheckboxGroup // This was already handled in DateRangeForm
              options={['60', '30', '15']}
              onChange={(v) => this.changeScheduleValue('meetingIncrement', v)}
            /> */}
        {/* </div> */}
      </>
    )
  }

  EventBodyForm = () => {
    // const [question, setQuestion] = useState('');

    // const [questions, setQuestions] = useState(
    // []
    // )

    const { t } = this.props; // Destructure t from props
    return (
      <>
        <CBHeader
          step={3}
          label={this.props.t('scheduler.event_details_header')}
          buttonLabel={this.props.t('sync.edit_previous_step')} // Reusing sync key
          buttonIcon={<Up></Up>}
          buttonAction={(e) => {
            this.setState({ page: this.state.page - 1 })
          }}
        ></CBHeader>
        <div>
          <div className="title_label">
            {this.props.t('scheduler.custom_subject_description_prefix')}{' '}
            {this.props.t('scheduler.custom_subject_variables')}
            {this.props.t('scheduler.custom_subject_description_suffix')}{' '}
            <a
              target="_blank"
              href="https://help.calendarbridge.com/doc/getting-started/creating-a-scheduling-link/#custom-subject"
            >
              {this.props.t('common.learn_more')}
            </a>
          </div>
          {this.state.existingScheduleId != null && (
            <CBInput
              maxLength={100}
              hint={this.props.t('scheduler.custom_subject_hint')}
              value={this.state.schedule.customSubject}
              onChange={(e) => this.changeScheduleValue('customSubject', e)}
            ></CBInput>
          )}

          {this.state.existingScheduleId == null && (
            <CBInput
              maxLength={100}
              hint={this.props.t('scheduler.custom_subject_hint')}
              value={this.state.schedule.customSubject}
              onChange={(e) => this.changeScheduleValue('customSubject', e)}
            ></CBInput>
          )}
        </div>
        <div>
          <div className="title_label">
            {this.props.t('scheduler.event_body_description_prefix')}
            {this.props.t('scheduler.event_body_description_suffix')}
          </div>

          <div style={{ textAlign: 'center', marginTop: 40 }}> {/* Replaced Paragraph */}
            <CBTextArea
              value={this.state.schedule.bodyTemplate}
              // size="large" // CBTextArea might not have size prop
              rows={6}
              onChange={(e) => this.changeScheduleValue('bodyTemplate', e)}
            />
          </div> {/* /Replaced Paragraph */}
        </div>

        <CBHeader subLabel={true} label={this.props.t('scheduler.booked_event_color_header')} />
        <div>
          <CBColorPicker
            key={`source-${this.state.schedule.source}-${
              this.state.allCalendars[parseInt(this.state.schedule.source)]
                .calendarAccountType
            }`}
            type={
              this.state.allCalendars[parseInt(this.state.schedule.source)]
                .calendarAccountType
            }
            onColorChangeCallback={(color) => {
              this.changeScheduleValue('destinationColor', color)
            }}
            color={this.state.schedule.destinationColor}
          ></CBColorPicker>
          <div tyle={{ marginTop: 20 }}>
            {/* Label: <Input defaultValue={this.state.schedule.displayName}></Input>
            Greeting: <Input defaultValue={this.state.schedule.ownerName}></Input> */}
          </div>
        </div>
        <div className="title_label">{this.props.t('scheduler.create_online_meeting_label')}</div>

        <div>
          {this.state.schedule && (
            <CBCheckItem
              checked={this.state.schedule.meeting}
              onChange={(e) => {
                if (e) {
                  var schedule = this.state.schedule
                  schedule.meeting = true
                  // schedule.integrations = []
                  this.setState({
                    schedule,
                  })
                } else {
                  var schedule = this.state.schedule
                  schedule.meeting = false
                  this.setState({
                    schedule,
                  })
                }
              }}
              label={
                <>
                  {this.props.t('scheduler.online_meeting_for_prefix')}{' '}
                  <b>
                    {this.state.allCalendars[
                      parseInt(this.state.schedule.source)
                    ].calendarAccountType == 'ms'
                      ? t('scheduler.provider_ms')
                      : t('scheduler.provider_google')}
                  </b>
                </>
              }
            ></CBCheckItem>
          )}
          {this.state.schedule.integrations &&
            this.props.integrations.map((integration) => {
              return (
                <div style={{ marginTop: 8, marginBottom: 8 }}>
                  <CBCheckItem
                    checked={this.state.schedule.integrations.includes(
                      integration.accountId
                    )}
                    key={integration.accountId}
                    onChange={(e) => {
                      if (e) {
                        var schedule = this.state.schedule
                        // schedule.meeting = false
                        schedule.integrations = [integration.accountId]

                        this.setState({
                          schedule,
                        })
                      } else {
                        var schedule = this.state.schedule
                        schedule.integrations = []
                        this.setState({
                          schedule,
                        })
                      }
                    }}
                    label={
                      <div className="flex flex-row text-sm">
                        {this.props.t('scheduler.zoom_integration_prefix')}{integration.email}
                      </div>
                    }
                  ></CBCheckItem>
                  {this.state.schedule.meeting &&
                    this.state.schedule.integrations.length > 0 && (
                      <div className="font-sarabun text-gray-900 mt-2">
                        {this.props.t('scheduler.meeting_choice_prefix')}{' '}
                        {this.state.allCalendars[
                          parseInt(this.state.schedule.source)
                        ].calendarAccountType == 'google'
                          ? t('scheduler.provider_google_meet')
                          : t('scheduler.provider_ms_teams')}
                      </div>
                    )}
                </div>
              )
            })}

          {this.props.integrations.length == 0 && (
            <div className="mt-2"> {/* Added margin */}
              <a
                className="text-blue-600 hover:underline cursor-pointer" // Added styling
                onClick={(e) => {
                  //save first
                  if (this.state.isLoading) {
                    // don't let them submit again if they already tapped
                  } else {
                    this.setState({ isLoading: true })
                    this.submitSync('zoom')
                  }
                }}
              >
                {this.props.t('scheduler.add_zoom_account')}
              </a>
            </div>
          )}
        </div>
        <div style={{ marginBottom: 8 }}>
          <div className="title_label">{this.props.t('scheduler.additional_attendees_label')}</div>
          {/* Replaced Ant Select (tags) with CBInput and manual tag handling */}
          <div className="flex flex-col">
            <div className="flex gap-x-2 items-center mb-2">
              <div className="flex-grow">
                <CBInput
                  placeholder={this.props.t('scheduler.additional_attendees_placeholder')}
                  value={this.state.attendeeInput}
                  onChange={(val) => this.setState({ attendeeInput: val, attendeeError: null })} // Update input state and clear error
                  onKeyDown={(e) => { // Add attendee on Enter key
                    if (e.key === 'Enter' && this.state.attendeeInput.trim()) {
                      e.preventDefault(); // Prevent form submission if any
                      const email = this.state.attendeeInput.trim();
                      if (validateEmail(email)) {
                        if (!this.state.schedule.additionalAttendees.includes(email)) {
                          this.changeScheduleValue(
                            'additionalAttendees',
                            [...this.state.schedule.additionalAttendees, email]
                          );
                          this.setState({ attendeeInput: '', attendeeError: null }); // Clear input and error
                        } else {
                           this.setState({ attendeeError: t('scheduler.error_attendee_already_added', { email: email }) });
                        }
                      } else {
                        this.setState({ attendeeError: t('scheduler.error_invalid_email_format', { email: email }) });
                      }
                    }
                  }}
                />
              </div>
               {/* Optional: Add button if Enter key is not preferred */}
               {/* <CBButton onClick={handleAddAttendee}>Add</CBButton> */}
            </div>
             {/* Display Error Alert */}
            {this.state.attendeeError && (
              <CBAlert type="error">{this.state.attendeeError}</CBAlert>
            )}
            {/* Display Added Attendees as Tags */}
            <div className="flex flex-wrap gap-2 mt-2">
              {this.state.schedule.additionalAttendees.map((email) => (
                <span key={email} className="inline-flex items-center px-2 py-1 rounded text-sm font-medium bg-blue-100 text-blue-800">
                  {email}
                  <button
                    type="button"
                    className="ml-1 flex-shrink-0 text-blue-400 hover:text-blue-500 focus:outline-none"
                    onClick={() => {
                      const updatedAttendees = this.state.schedule.additionalAttendees.filter(a => a !== email);
                      this.changeScheduleValue('additionalAttendees', updatedAttendees);
                    }}
                  >
                    &times; {/* Simple close icon */}
                  </button>
                </span>
              ))}
            </div>
          </div>
        </div>

        <div style={{ marginBottom: 8 }}>
          <div className="title_label">
            {this.props.t('scheduler.add_question_label')}
          </div>
          <div className="flex gap-x-4 items-center">
            <div className="flex-grow mb-2">
              <CBInput
                maxLength={128}
                style={{ marginTop: 8, marginBottom: 8 }}
                placeholder={this.props.t('scheduler.question_placeholder')}
                value={this.state.questionInputValue}
                onChange={(e) =>
                  this.setState((prevState) => ({
                    ...prevState,
                    questionInputValue: e,
                  }))
                }
              ></CBInput>
            </div>
            <div>
              <CBButton
                id="questions"
                key="questions"
                disabled={
                  this.state.questionInputValue == '' ||
                  this.state.questionInputValue == null
                }
                onClick={(e) => {
                  this.state.schedule.questions.push(
                    this.state.questionInputValue
                  )
                  this.setState((prevState) => ({
                    ...prevState,
                    questionInputValue: '',
                  }))
                  // setQuestions(questions)

                  this.changeScheduleValue(
                    'questions',
                    this.state.schedule.questions
                  )
                }}
              >
                {this.props.t('common.add_button')}
              </CBButton>
            </div>
          </div>
        </div>
        {this.state.schedule.questions.length > 0 && (
          <>
            <div className="title_label">{this.props.t('scheduler.questions_list_header')}</div>
            <div style={{ marginTop: 8, marginBottom: 8 }}>
              {this.state.schedule.questions.map((e) => {
                return (
                  <div className="mb-2">
                    <CBListItem
                      borderLight={true}
                      icon={<Trash></Trash>}
                      onClick={(ev) => {
                        var qs = this.state.schedule.questions.filter((q) => {
                          return q != e
                        })
                        // setQuestions(qs)
                        this.changeScheduleValue('questions', qs)
                      }}
                    >
                      {e}
                    </CBListItem>
                  </div>
                )
              })}
            </div>
          </>
        )}
      </>
    )
  }

  render() {
    const sourceCalendar = this.state.allCalendars[
      +this.state.schedule.source
    ] || {
      name: this.props.t('sync.not_selected'), // Reusing sync key
      incomplete: true,
    }

    const pages = [this.SourceForm, this.DateRangeForm, this.EventBodyForm]

    return (
      <Layout className="flex flex-col lg:flex-row ">
        <Content className="cb-content-frame flex-grow" style={{ background: 'white' }}>
          <div className="cb-content-pane mobile_padding min-h-screen">
            <MediaQuery maxDeviceWidth={1224}>
              {this.renderSteps(true)}
            </MediaQuery>

            {pages[this.state.page]()}
            {this.state.quickSave && (
              <div className="fixed inset-x-0 bottom-0 flex justify-center p-4">
                <CBButton
                  loading={this.state.isLoading}
                  onClick={(e) => {
                    this.setState({ isLoading: true })
                    this.submitSync()
                  }}
                >
                  {this.state.otherError && 'Missing Calendar Removed'}{'. '} 
                  {this.props.t('scheduler.save_changes_button')}
                </CBButton>
              </div>
            )}
            <div className="mb-4"></div>
            {/* Added conditional alert for meeting length error */}
            {this.state.meetingLengthError && (
              <CBAlert type="error">{this.state.meetingLengthError}</CBAlert>
            )}
            <SubmitButton
              badge={this.state.page + 1}
              type="primary"
              block
              size="large"
              onClick={this.nextPage}
              disabled={
                this.state.isLoading || this.state.schedule.source == null
              }
            >
              {this.getButtonLabelByStep()}
            </SubmitButton>
            <CBModal
              wide={true}
              visible={this.state.showModal}
              disabled={this.state.isLoading}
              onPositiveClick={(e) => {
                this.setState({ isLoading: true })
                this.submitSync()
              }}
              onCancelClick={(e) =>
                this.setState({ isLoading: false, showModal: false })
              }
            >
              {this.state.showModal && (
                <ScheduleItem
                  item={this.createFauxItem()}
                  preview={true}
                ></ScheduleItem>
              )}
            </CBModal>
          </div>
        </Content>
        <MediaQuery minDeviceWidth={1224}>
          <Sider width={400} className="sider-style">
          <aside className="w-full md:w-[400px] h-full md:flex-shrink-0 bg-gray-50 border-l border-gray-200">
          
            <div className="ml-12 mr-12 mt-4">
              <div className="ml-5 mb-2">
                <CBHeader
                  label={this.props.t('home.create_scheduler')} // Reusing home key
                  icon={<NewSchedule />}
                ></CBHeader>
              </div>
              {this.renderSteps()}
            </div>
            </aside>
          </Sider>
        </MediaQuery>
      </Layout>
    )
  }

  getTimeMatrixDisplay() {
    // return "FUCL"
    const {
      startTimeSun,
      endTimeSun,
      startTimeMon,
      endTimeMon,
      startTimeTue,
      endTimeTue,
      startTimeWed,
      endTimeWed,
      startTimeThu,
      endTimeThu,
      startTimeFri,
      endTimeFri,
      startTimeSat,
      endTimeSat,
    } = this.state.schedule
    var timeMatrix = {
      Mon: {
        start: startTimeMon,
        end: endTimeMon,
      },
      Tue: {
        start: startTimeTue,
        end: endTimeTue,
      },
      Wed: {
        start: startTimeWed,
        end: endTimeWed,
      },
      Thu: {
        start: startTimeThu,
        end: endTimeThu,
      },
      Fri: {
        start: startTimeFri,
        end: endTimeFri,
      },
      Sat: {
        start: startTimeSat,
        end: endTimeSat,
      },
      Sun: {
        start: startTimeSun,
        end: endTimeSun,
      },
    }

    return this.state.schedule.days.map((d) => (
      <div>
        {d} {timeMatrix[d].start.format('h:mm a')} -{' '}
        {timeMatrix[d].end.format('h:mm a')}
      </div>
    ))
  }
  renderSteps(mobile = false) {
    const sourceCalendar = this.state.allCalendars[
      +this.state.schedule.source
    ] || {
      name: this.props.t('sync.not_selected'), // Reusing sync key
      incomplete: true,
    }
    return (
      <CBSteps
        direction="vertical"
        mobile={mobile}
        page={this.state.page}
        onPageChanged={(p) => this.changePage(p)}
        style={{ marginBottom: 40, marginTop: 40 }}
      >
        <CBStep
          primary={this.props.t('scheduler.step1_primary')}
          secondary={sourceCalendar.name || sourceCalendar.summary}
        />
        <CBStep
          primary={this.props.t('scheduler.step2_primary')}
          secondary={this.getTimeMatrixDisplay()}
          disabled={sourceCalendar.incomplete}
        />

        <CBStep
          primary={this.props.t('scheduler.step3_primary')}
          secondary={
            this.state.schedule.bodyTemplate.length === 0
              ? this.props.t('scheduler.step_empty')
              : this.state.schedule.bodyTemplate.substring(0, 20) + '...'
          }
          disabled={sourceCalendar.incomplete}
        />
      </CBSteps>
    )
  }
}

const ScheduleCreatePageState = ({ id }) => {
  const { t } = useLocalization()
  const [accounts] = useGlobalState('accounts')
  const [schedules] = useGlobalState('schedules')
  const [license] = useGlobalState('license')
  const [integrations] = useGlobalState('integrations')
  const navigate = useNavigate()

  return (
    <>
      <SEO title="Create a Scheduler" />
      <ScheduleCreatePage
        id={id}
        accounts={accounts}
        schedules={schedules}
        license={license}
        integrations={integrations}
        navigate={navigate}
        t={t} // Pass t function as prop
      />
    </>
  )
}

export default ScheduleCreatePageState
